import type { WorkspaceObject } from '../../types/index.js';
import { safeJsonDate } from './date.js';

export const normalizeWorkspaceObject = (data: WorkspaceObject<string> | null): WorkspaceObject | null => {
  if (!data) return null;

  return Object.assign(data, {
    createdOn: safeJsonDate(data.createdOn),
    expiresOn: data.expiresOn ? safeJsonDate(data.expiresOn) : undefined,
  });
};